import Select, { SelectProps } from "@amzn/awsui-components-react/polaris/select";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import { ReportFolder } from "Api/useQueryListReports";

interface ReportSelectorProps {
  readonly folders: ReportFolder[];
  readonly selectedFolder: string;
  readonly onSelect: (folder: string) => void;
}

const ReportSelector = ({ folders, selectedFolder, onSelect }: ReportSelectorProps) => {
  const options: SelectProps.Option[] = folders.map((report) => ({
    value: report.folderName,
    label: report.month,
  }));

  const selectedOption = options.find((opt) => opt.value === selectedFolder) || null;

  const handleChange = ({ detail }: { detail: SelectProps.ChangeDetail }) => {
    onSelect(detail.selectedOption.value ?? "");
  };

  return (
    <FormField label="Select a report">
      <Select
        selectedOption={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder="Choose a report"
        filteringType="auto"
        empty="No reports available"
      />
    </FormField>
  );
};

export default ReportSelector;
